import { useState, useEffect } from 'react'
import { Button, Typography } from '@material-ui/core'
import { makeStyles, Theme as AugmentedTheme } from '@material-ui/core/styles'
import { SelectorItemSize } from '../utils/types'
import { MOTOR_IMAGE_PLACEHOLDER } from '../utils/lib'
import CircularProgress from '@material-ui/core/CircularProgress'

type AMMotor = {
  keyAttr?: string
  value?: string
  onClick?: (v: string) => void
  selected?: boolean
  size?: SelectorItemSize
  disabled?: boolean
  carousel?: boolean
  img?: string
  label: string
  subLabel?: string
}
const useStyles = makeStyles((theme: AugmentedTheme) => ({
  root: {
    padding: theme.spacing(2),
    color: 'black',
    borderRadius: '4px',
    border: '1px solid #e0e0e0',
    // margin: theme.spacing(1),
    marginLeft: 'inherit',
    textTransform: 'inherit',
    backgroundColor: 'white',
    '& > span': { flexDirection: 'column', display: 'flex' },
    '&.selected': {
      color: 'black',
      border: '1px solid #e0e0e0',
    },
    '&.disabled': {
      color: 'black',
      border: '1px solid #e0e0e0',
    },
    '&:hover': {
      backgroundColor: 'white',
    },
    '& img': {
      height: '106px',
      marginBottom: theme.spacing(3),
    },
    imageWrapper: {
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
      width: '100%',
    },
  },
  subLabel: {
    fontSize: '16px',
    lineHeight: '30px',
  },
}))

export const AMSelectorItem = ({
  keyAttr,
  disabled,
  value,
  size,
  img,
  label,
  subLabel,
  selected,
  onClick,
}: AMMotor) => {
  const classes = useStyles()
  const [displayImg, setDisplayImg] = useState<string | undefined>(img)

  useEffect(() => {
    setDisplayImg(img)
  }, [img])

  return (
    <Button
      key={keyAttr ? keyAttr : 'am-selector-item'}
      disabled={disabled}
      className={`${classes.root}  ${selected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
      color="primary"
      onClick={() => {
        onClick && value ? onClick(value) : null
      }}
    >
      {size !== SelectorItemSize.Small && (
        displayImg === undefined ? (
          <div
            className={classes.imageWrapper}
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 106 }}
          >
            <CircularProgress size={40} style={{ color: 'black' }} />
          </div>
        ) : (
          <img
            src={displayImg}
            alt="img"
            onError={() => setDisplayImg(MOTOR_IMAGE_PLACEHOLDER)}
          />
        )
      )}
      <Typography variant="h2">{label}</Typography>
      {subLabel ?? <span className={classes.subLabel}>{subLabel}</span>}
    </Button>
  )
}
